// @core/api/endpoints/tenant/update_tenant_member_role.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TenantMemberResponse,
  UpdateTenantMemberRoleRequest,
} from '../../../types/tenant';

const BASE_PATH = '/tenant';

/**
 * Update member role in tenant
 * Changes the role of an existing tenant member. Role changes take effect immediately and affect the member's permissions within the tenant.
 */
export async function UpdateTenantMemberRole(
  tenant_id: string,
  user_id: string,
  data: UpdateTenantMemberRoleRequest,
  options?: RequestOptions
): Promise<TenantMemberResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id/members/:user_id/role`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  requestPath = requestPath.replace(':user_id', encodeURIComponent(user_id));
  const requestOptions = options;
  return client.put<TenantMemberResponse>(requestPath, data, requestOptions);
}
